import { getCookie, setCookie } from './cookieUtils'

export type Environment = string | 'production' | 'staging' | undefined

function getCookieDomain(env: Environment) {
  return env === 'production' || env === 'staging'
    ? ';domain=stratascratch.com'
    : ''
}

function tokenUtils(env?: Environment) {
  const TOKEN_STORAGE_KEY =
    !env || env === 'production'
      ? 'system_user_logged'
      : `system_user_logged_${env}`

  function saveTokenToLocalStorage(token: string) {
    localStorage.setItem(TOKEN_STORAGE_KEY, token)
  }

  function saveTokenToCookie(token: string) {
    const cookieDomain = getCookieDomain(env)
    setCookie(TOKEN_STORAGE_KEY, `${token} ${cookieDomain}`, 60)
  }

  function getTokenFromLocalStorage() {
    return localStorage.getItem(TOKEN_STORAGE_KEY)
  }

  function getTokenFromCookie() {
    return getCookie(TOKEN_STORAGE_KEY)
  }

  function getToken() {
    // Phasing out localStorage in favor of cookie because the cookie allows reading across subdomains

    // Prioritize cookie and clear the localStorage just in case
    const cookieToken = getTokenFromCookie()
    if (cookieToken) {
      localStorage.removeItem(TOKEN_STORAGE_KEY)
      return cookieToken
    }

    // If we have the token in localStorage save it to cookie and clear the localStorage
    const localStorageToken = getTokenFromLocalStorage()
    if (localStorageToken) {
      saveTokenToCookie(localStorageToken)
      localStorage.removeItem(TOKEN_STORAGE_KEY)
      return localStorageToken
    }

    return null
  }

  function deleteTokenCookie() {
    const cookieDomain = getCookieDomain(env)
    setCookie(TOKEN_STORAGE_KEY, ` ${cookieDomain}`, -999)
  }

  return {
    getToken,
    saveTokenToCookie,
    deleteTokenCookie,
    saveTokenToLocalStorage,
  }
}

export default tokenUtils
